// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#navigation {
  align-items: center;
  display: flex;
  justify-content: space-around;
  max-height: 12vh;
}

#navigation .section {
  align-items: center;
  cursor: pointer;
  display: flex;
  flex: 1 1;
  height: 100%;
  justify-content: center;
}

#navigation .section img {
  height: 30%;
}

#feedback {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  max-height: 3vh;
  margin-bottom: 0.5rem;
}

#feedback img {
  height: 80%;
  margin-right: 0.5rem;
}

#feedback span {
  color: #233289;
  font-size: 0.875rem;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/navigation/Navigation.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,SAAO;EACP,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,0BAA0B;AAC5B","sourcesContent":["#navigation {\n  align-items: center;\n  display: flex;\n  justify-content: space-around;\n  max-height: 12vh;\n}\n\n#navigation .section {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  flex: 1;\n  height: 100%;\n  justify-content: center;\n}\n\n#navigation .section img {\n  height: 30%;\n}\n\n#feedback {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  max-height: 3vh;\n  margin-bottom: 0.5rem;\n}\n\n#feedback img {\n  height: 80%;\n  margin-right: 0.5rem;\n}\n\n#feedback span {\n  color: #233289;\n  font-size: 0.875rem;\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
